import createWithBsPrefix from './utils/createWithBsPrefix';
export default createWithBsPrefix('modal-footer');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/es/ModalFooter.js
// module id = 139
// module chunks = 0